import { LegalPage } from "./LegalPage";
import { Placeholder } from "./Placeholder";

/**
 * Terms of Service — the single source for the /terms page.
 *
 * Every <Placeholder> lists what that section must cover. Replace it with
 * the approved legal text (from the owner or their lawyer) and set
 * `lastUpdated` once the wording is final.
 */
export function TermsPage() {
  return (
    <LegalPage title="Terms of Service" lastUpdated="">
      <Placeholder>
        <p>
          These Terms of Service are a draft outline. The final text must be
          supplied by Haven's owner or legal counsel before launch.
        </p>
      </Placeholder>

      <h2>Acceptance of these terms</h2>
      <Placeholder>
        <p>Who the agreement is between (legal entity name), and how using Haven or creating an account constitutes acceptance.</p>
      </Placeholder>

      <h2>Accounts and eligibility</h2>
      <Placeholder>
        <p>Minimum age, accurate account information, responsibility for credentials, and organization/team accounts (owners, admins, invited members).</p>
      </Placeholder>

      <h2>The service</h2>
      <Placeholder>
        <p>What Haven does: storing, organizing, and processing uploaded documents, including automated AI renaming and tagging by third-party AI providers, and that AI output may be inaccurate.</p>
      </Placeholder>

      <h2>Your content</h2>
      <Placeholder>
        <p>Ownership of uploaded documents, the limited license Haven needs to store and process them (including sending them to AI providers), and the user's responsibility for having the right to upload them.</p>
      </Placeholder>

      <h2>Acceptable use</h2>
      <Placeholder>
        <p>Prohibited content and conduct, and Haven's right to suspend accounts that violate it.</p>
      </Placeholder>

      <h2>Subscriptions, billing, and refunds</h2>
      <Placeholder>
        <p>Plans and credits, payment processing by Stripe, renewal and cancellation, price changes, taxes, and the refund policy.</p>
      </Placeholder>

      <h2>Termination</h2>
      <Placeholder>
        <p>How either side can end the agreement and what happens to the user's documents afterwards (cross-reference the Privacy Policy's retention section).</p>
      </Placeholder>

      <h2>Disclaimers and limitation of liability</h2>
      <Placeholder>
        <p>Warranty disclaimer, liability cap, and exclusions, as drafted by counsel.</p>
      </Placeholder>

      <h2>Governing law and disputes</h2>
      <Placeholder>
        <p>Jurisdiction, venue, and any dispute-resolution terms.</p>
      </Placeholder>

      <h2>Changes to these terms</h2>
      <Placeholder>
        <p>How users are notified of changes and when changes take effect.</p>
      </Placeholder>

      <h2>Contact</h2>
      <Placeholder>
        <p>Legal entity name, postal address, and a contact email for legal notices.</p>
      </Placeholder>
    </LegalPage>
  );
}
